module.exports = __webpack_public_path__ + "static/media/img3.9b4d809d.jpg";